module.exports = __webpack_public_path__ + "img/rune-invisibility.47c345f4.png";